import React from "react";
import { Modal, Button, Row } from "antd";
import SuccessIcon from "../../Icons/SuccessIcon";
import FailureIcon from "../../Icons/FailureIcon";

export default function ActionConfirmationModal({
  modalDetails,
  callback,
  modalContent,
}) {
  const { isVisible, type, message, errorMessage } = modalDetails;

  return (
    <div>
      <Modal
        width="25%"
        visible={isVisible}
        onOk={callback}
        footer={false}
        closable={false}
        maskClosable={false}
      >
        <div className="confirmation-title-container">
          {modalDetails?.type?.includes("success") ? (
            <SuccessIcon />
          ) : (
            <FailureIcon />
          )}
          <span>
            <b>{modalContent[type]?.title}</b>
          </span>
        </div>
        <div className="confirmation-message-container">
          <p>{errorMessage ? errorMessage : modalContent[type]?.text}</p>
        </div>
        <div className="confirmation-button-container">
          <Button onClick={() => callback()} className="confirmation-btn">
            Aceptar
          </Button>
        </div>
      </Modal>
    </div>
  );
}
